<template>
  <div class="product-card">
    <div class="product_box">
      <img src="../assets/img/Group.png" class="Group" alt="" v-if="this.endTime">
      <div class="ProImg" @click="goToProductDetail(item)">
        <a><img :src="this.img" alt=""></a>
      </div>
      <div class="Pro-Details">
        <div v-if='this.endTime' class="countdownTimerContainer">
          <p v-if='$i18n.locale=="en"' class="countdownTimer">{{this.timeDay}}<span>D</span> {{this.timeHour}}<span>H</span> {{this.timeMin}}<span>M</span> {{this.timeSec}}<span>S</span></p>
          <p v-if='$i18n.locale=="ch"' class="countdownTimer">{{this.timeDay}}<span>天</span>{{this.timeHour}}<span>时</span>{{this.timeMin}}<span>分</span>{{this.timeSec}}<span>秒</span></p>
        </div>
        <div v-if='!this.endTime' class="emptyTimerContainer">
        </div>
        <!-- <div class="remainingContainer">
          <p>剩下:</p>
        </div> -->
        <p class="ProTitle"><a :href="this.link">{{this.name}}</a></p>
        <div class="price-bot">
          <div class="price-marge">
            <div :class="['price__regular', this.isPromotion ? 'hot' : '']"><span>${{item ? item.Price.toFixed(2) : ''}}</span></div>
            <div class="price_original" v-show="isPromotion"><span>${{item.OriginalPrice ? item.OriginalPrice.toFixed(2) : ''}}</span></div>
          </div>
          <!-- <button v-if="isOutOfStock(item)" class="ajax_addto_cart_btn">{{ $t('outOfStock') }}</button> -->
          <button v-if="isOutOfStock(item) || (this.GroupedSaleLimit > 0 && !(this.GroupedSaleLimit - this.GroupSoldQuantity > 0))" class="ajax_addto_cart_btn">{{ $t('noStock') }}</button>
          <div v-else-if="found && windowWidth >= 450" class="qty_and_cart">
            <div class="mobileqty">
              <div class="qty_input">
                <div class="addsub">
                  <button @click="incrementAddToCart(item, false, $event)" class="decrement">-</button>
                  <span class="cart-quantity">{{this.num}}</span>
                  <button :disabled="this.addDisabled" @click="throttleAddToCart(item, $event)" class="increment">+</button>
                </div>
              </div>
            </div>
            <div v-if="!item.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
              <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
              <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                <span id="AddToCartText-product-template">Sold out</span>
              </button>
            </div>
          </div>
          <div v-else class="qty_and_cart">
            <div class="mobileqty">
              <div class="qty_input">
                <button v-if="this.num === 0"
                  :disabled="this.addDisabled"
                  @click="throttleAddToCart(item, $event)" 
                  class="increment"
                >+</button>
                <button v-else
                  :disabled="this.addDisabled"
                  @click="throttleAddToCart(item, $event)" 
                  class="increment"
                >{{this.num}}</button>
              </div>
            </div>
            <div v-if="!item.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
              <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
              <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                <span id="AddToCartText-product-template">Sold out</span>
              </button>
            </div>
          </div>
          <div v-if="((this.GroupedSaleLimit - this.GroupSoldQuantity) > 0) && !isOutOfStock(item) && this.endTime" class="remainingContainer">
            <p v-if='$i18n.locale=="en"'>{{this.GroupedSaleLimit - this.GroupSoldQuantity}} Left!</p>
            <p v-if='$i18n.locale=="ch"'>剩下: {{this.GroupedSaleLimit - this.GroupSoldQuantity}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import breadcrumb from "@/components/breadcrumb";
import { mapActions, mapState, mapMutations } from 'vuex';
import { flyToElement } from "../store/modules/cart.js";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
export default {
  name: 'productCard',
  props: [
    'img',
    'link',
    'name',
    'isPromotion',
    'price',
    'item',
    'quantity',
    'group',
    'endTime',
    'GroupedSaleLimit',
    'GroupSoldQuantity',
  ],
  data() {
    return {
      list: [],
      found: false,
      num: 0,
      localCount: 0,

      currentTime: new Date(),
      timeDay: null,
      timeHour: null,
      timeMin: null,
      timeSec: null,

      addDisabled: false,
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('cart', ['updateProductCount']),
    ...mapActions('cart',['addProductToCart']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false;
      }
      return item.StockLevel > 0 ? false : true
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/addCart', item);
        this.found = true;
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
      this.$store.dispatch('cart/getCart');
    },
    getItemQuantity: function() {
      if (isUserAuthenticated() && this.cartProductsList && this.cartProductsList.Sales_Order_Lines) {
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
            this.found = true;
          } 
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    incrementAddToCart: function(item, add, e) {
      if (add) {
        let quantity = this.num + 1;
        if (isUserAuthenticated()) {
          flyToElement(event.target, $('.cart-link'));
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.getItemQuantity();
          })
        } else {
          this.$store.dispatch('cart/addProductToLocalCart', item);
        }
      } else if (!add) {
        let quantity = this.num - 1;
        if (quantity < 1) {
          this.deleteItem(item)
        } else {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
          } else {
            item.quantity = quantity;
            this.$store.dispatch('cart/updateLocalCart', item)
            .then(() => {
              this.$store.dispatch('cart/fetchCartProducts')
            });
          }
        }
      }
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addDisabled = true;
      setTimeout(() => this.addDisabled = false, 1000);
      // console.log('加入')
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})   
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item, event])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      flyToElement(payload.event.target, $('.cart-link')); 
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
    checkInsideCart() {
      if (isUserAuthenticated() && this.cartProductsList && this.cartProductsList.Sales_Order_Lines) {
        if (!this.cartProductsList.Sales_Order_Lines.length) {
          this.found = false;
          this.num = 0;
          return;
        }
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            return;
          }
        }
      } else {
        //For whatever reason this portion is necessary for removing the found variable when 
        //itemCount is below 1. 
        if (!this.cartProductsList.length) {
          this.found = false; 
          this.num = 0;
          return;
        } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            }
          }
        }
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount])
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
  },
  mounted() {
    this.checkInsideCart();
    this.getItemQuantity(this.item);
    let that = this;
    if (this.endTime) {
      // console.log("timer created");
      setInterval( function(){that.currentTime = new Date();}, 1000);
    }
  },
  beforeUpdate() {
    this.checkInsideCart();
    this.getItemQuantity(this.item);
  },
  computed: mapState({
    cartProductsList: state => state.cart.cartProductsList,
    itemCount: state => state.cart.itemCount,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    windowHeight: state => state.navbar.windowHeight, 
    windowWidth: state => state.navbar.windowWidth,
  }),
  watch: {
    cartProductsList: function(newVal, oldVal) {
      if (newVal !== oldVal || newVal.length !== oldVal.length) {
        this.checkInsideCart();
        this.getItemQuantity(this.item);
      }
    },
    currentTime: function(newVal, oldVal) {
      let diffTime = Math.abs(moment(this.endTime) - moment(this.currentTime)) / 1000;
      this.timeDay = Math.floor(diffTime / 86400);
      diffTime -= this.timeDay * 86400;
      if (this.timeDay < 10) {
        this.timeDay = '0' + this.timeDay;
      }
      this.timeHour = Math.floor(diffTime / 3600) % 24;
      diffTime -= this.timeHour * 3600;
      if (this.timeHour < 10) {
        this.timeHour = '0' + this.timeHour;
      }
      this.timeMin = Math.floor(diffTime / 60) % 60;
      diffTime -= this.timeMin * 60;
      if (this.timeMin < 10) {
        this.timeMin = '0' + this.timeMin;
      }
      this.timeSec = Math.floor(diffTime % 60);
      if (this.timeSec < 10) {
        this.timeSec = '0' + this.timeSec;
      }
    },
  }
}
</script>

<style scope lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productCard.less";
</style>



// WEBPACK FOOTER //
// src/view/productCard.vue